var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.219 15.75a.422.422 0 00.422-.422v-2.531h1.687a.422.422 0 00.422-.422V9a2.11 2.11 0 00-2.11-2.11V4.885c0-.336-.133-.658-.37-.895L11.902 2.62a1.266 1.266 0 00-.895-.371H5.163c-.444 0-.804.378-.804.844V6.89A2.11 2.11 0 002.25 9v3.375c0 .233.189.422.422.422h1.687v2.531c0 .233.19.422.422.422h8.438zm-.248-6.353a.397.397 0 110 .794.397.397 0 010-.794zm-2.284-5.46v1.266c0 .233.19.422.422.422h1.266v1.688h-6.75V3.938h5.063zm1.688 10.97h-6.75v-1.688h6.75v1.687z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/33f2e573c1765c8ff351f87f42e4920c-Print.svg";
export { SvgPrint as ReactComponent };